import { render, staticRenderFns } from "./SalesList.vue?vue&type=template&id=60c7b198&scoped=true"
import script from "./SalesList.vue?vue&type=script&lang=js"
export * from "./SalesList.vue?vue&type=script&lang=js"
import style0 from "./SalesList.vue?vue&type=style&index=0&id=60c7b198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c7b198",
  null
  
)

export default component.exports